import React, {useState} from "react";

//routing
import {useHistory} from "react-router-dom";

//css
import "../css/style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {Col, Container, Row, Card, Button} from "react-bootstrap";

//component
import Navbar from "../components/NavBar";

//ant design
import {Input} from "antd";

//toast
import {alert} from "../util/toast";

//dayjs
import dayjs from "dayjs";

const Payment = (props) => {
  const history = useHistory();
  const [apply, setApply] = useState(false);
  const [amount, setAmount] = useState(15);
  const userData = JSON.parse(localStorage.getItem("Detail"));
  const interViewData = JSON.parse(localStorage.getItem("InterViewData"));

  const handleApply = () => {
    setApply(!apply);
  };

  const razorPayPayment = () => {
    displayRazorpay();
  };

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  async function displayRazorpay() {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("error", "Razorpay SDK failed to load. Are you online?");
      return;
    }

    const options = {
      key: "rzp_test_qyeJ3Tm2k76T3H", // Enter the Key ID generated from the Dashboard
      amount: amount.toString() + "00",
      currency: "USD",
      name: "PreWithMock",
      handler: async function (response) {
        alert(`success`, "Payment made successfully!");
        setTimeout(() => {
          history.push("/interviewer");
        }, [3000]);
      },
      prefill: {
        name: userData.name,
        email: userData.email,
      },
      theme: {
        color: "#0093FF",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  return (
    <>
      <Navbar />
      <div className="bgColor">
        <Container fluid="sm">
          <Row className="py-5">
            <Col className="py-3 border-right">
              <img
                alt=""
                src="/icon.png"
                width="70"
                height="70"
                className="d-inline-block"
              />
              <span
                className="pl-2 "
                style={{fontSize: 32, textShadow: "1px 1px gray"}}
              >
                PrepWithMock
              </span>
              <Col className="pt-5">
                <img
                  alt=""
                  src="/interviewIcon.jpg"
                  height="auto"
                  width="350"
                  style={{objectFit: "cover"}}
                  className="img-fluid d-inline-block"
                />
              </Col>
            </Col>

            <Col className="py-3 border-left">
              <h3 className="text-center font-weight-bold pb-5">
                Order Details
              </h3>

              <Card
                className="cardBg shadow-lg mx-auto "
                style={{width: "90%", borderRadius: 15}}
              >
                <Card.Body>
                  <Card.Title className="py-2 px-3">
                    <p className="text-secondary font-weight-bold mb-0">
                      {userData.name}
                    </p>
                    <p className="text-secondary font-weight-bold border-bottom pb-4">
                      {userData.email}
                    </p>
                  </Card.Title>
                  <Card.Title className="mb-2 text-dark p-2 font-weight-bold">
                    {interViewData?.interViewType}
                  </Card.Title>
                  <Card.Subtitle className="text-dark pl-2 py-2">
                    Company : {interViewData?.company}
                  </Card.Subtitle>
                  <Row className="border-bottom pl-2 pb-4">
                    <Col lg={5} sm={1}>
                      <Card.Subtitle className="text-dark py-2">
                        Schedule :{" "}
                        {dayjs(interViewData?.date).format("DD MMM'YY")}
                      </Card.Subtitle>
                    </Col>
                    <Col lg={6} sm={1} className="px-lg-0">
                      <Card.Subtitle className="text-dark py-2 ">
                        Timings :&nbsp;
                        {interViewData?.time.map((data) => {
                          return data + ":00  ";
                        })}
                      </Card.Subtitle>
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col>
                      <Card.Title className="mb-2 text-dark p-2 font-weight-normal">
                        Total :
                      </Card.Title>
                    </Col>
                    <Col>
                      <Card.Title className="mb-2 text-dark text-right p-2 font-weight-normal">
                        $15
                      </Card.Title>
                    </Col>
                  </Row>
                  <Row className="mt-1">
                    {!apply ? (
                      <Col
                        className="bg-light mx-3 inputDiv"
                        style={{borderRadius: 7, border: "2px solid #FFD6D4"}}
                        onClick={handleApply}
                      >
                        <img
                          alt=""
                          src="/Capture.png"
                          width="40"
                          className="d-inline-block"
                        />
                        <span
                          className="font-weight-bold pb-5 ml-2"
                          style={{fontSize: 16}}
                        >
                          Apply coupan
                        </span>
                      </Col>
                    ) : (
                      <Col>
                        {/* <Input size="large" placeholder="Enter coupan code" onChange={(e) => setAmount(e.target.value)} /> */}
                        <Input size="large" placeholder="Enter coupan code" />
                      </Col>
                    )}
                  </Row>
                  <Row className="mt-4">
                    <Col className="text-center">
                      <Button
                        type="primary"
                        className="shadow"
                        onClick={razorPayPayment}
                      >
                        Proceed to Pay
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Payment;
